<template>
  <div class="main-container">
    <div class="tabberHeight">
      <!-- <div class="isShowLoading" color="#aab" v-if="isShowLoading">
        <van-loading vertical type="spinner" />
        <van-overlay :show="isShowLoading" />
      </div> -->
      <!-- <follow></follow> -->
      <!-- 新人首单大礼包 -->
      <!-- <div v-if="activityPic&&activityPic.isShowPageActivity!==null">
        <transition name="fade"
                    appear>
          <div v-show="activityPic.isShowPageActivity"
               @touchmove.prevent
               @mousewheel.prevent
               class="pop_share">
            <div class="pop_position">
              <div class="pop_share_box"
                   @click="onActivityClick">
                <img :src="activityPic.picUrl" />
              </div>
              <div style="margin: 24px 0; text-align: center">
                <van-icon name="close"
                          size="30"
                          color="#fff"
                          style="opacity: 0.5;"
                          @click="closePop()" />
              </div>
            </div>
          </div>
        </transition>
      </div> -->

      <div v-if="showEmpty">
        <div v-for="item in pageData" :key="item.fitUpModuleId">
          <div v-if="item.moduleType == 'banner'">
            <van-swipe indicator-color="#fff" :loop="true" :autoplay="3000" v-if="activated">
              <van-swipe-item loop v-for="image in item.bannerModuleItems" :key="image.id" v-lazy="image"
                @click="onSwiperClick(image.linkTypeId, image.link_Id, image)">
                <div>
                  <van-image width="100%" fit="contain" :src="image.imageUrl"></van-image>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
          <div v-if="item.moduleType == 'package'">
            <van-cell @click="showPopup">
              <div>
                <van-image :src="item.pictureUrl" />
              </div>
            </van-cell>
            <van-popup v-model="show" class="pagePopup">
              <van-grid :column-num="1" v-for="good in item.packageItemModules" :key="good.goodsId"
                style="background: #fff">
                <div>
                  <div class="pagepackageModule">
                    <van-grid-item v-for="sku in good.packageItemModuleSkus" :key="sku.skuId">
                      <van-card :num="sku.quantity" :price="sku.unitPrice / 100" :desc="sku.specificationNames"
                        :title="good.goodsName" :thumb="sku.pictureUrl" class="card_shop"></van-card>
                    </van-grid-item>
                  </div>
                </div>
                <!-- <div class="packageNum">
                本产品在一口价中最少购买
                <span style="color: #b80014;">{{good.minQuantity}}</span>件最多购买
                <span style="color: #b80014;">{{good.maxQuantity}}</span>件
              </div>-->
              </van-grid>
              <van-grid clickable :column-num="2">
                <van-grid-item text="取消" @click="cancel" class="cancel" />
                <van-grid-item text="立即购买" @click="clickUrlPackage(item.packageId)" class="buy" />
              </van-grid>
            </van-popup>
          </div>

          <div v-if="item.moduleType == 'limitgoods'" :id="'id' + item.moduleType">
            <van-grid :column-num="2" gutter="3vw" class="limitgoods-grid">
              <van-grid-item v-for="goods in item.goodsModuleItems" :key="goods.goodsCode"
                style="width: 100%; padding-top: 3vw">
                <div @click="onGoodsClick(goods)" v-if="goods.limitQuantity !== undefined && !goods.isExpired">
                  <div class="image">
                    <van-image :src="goods.goodsImageUrl" />
                  </div>
                  <div class="grid_bottom goodsGrid" style="width: 100%">
                    <div class="activeText">
                      <div class="activeName">{{ goods.goodsName }}</div>

                      <!-- <div class="activedesc" v-if="goods.userLimit < goods.limitQuantity">限购{{ goods.limitQuantity }}件，已购{{ goods.userLimit }}件</div> -->
                      <span class="activedescEnd" v-if="goods.isExpired">活动已截止</span>
                      <div v-else>
                        <span class="activedescEnd" v-if="goods.userLimit >= goods.limitQuantity">限购件数已用完</span>
                        <span class="activedesc" v-if="goods.userLimit < goods.limitQuantity">限购{{ goods.limitQuantity
                          }}件，已购{{
                            goods.userLimit
                          }}件</span>
                      </div>
                      <div class="activeprice">
                        ￥{{ goods.goodsPrice }}
                        <span class="activeLinePrice">￥{{ goods.originPrice }}.00</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div @click="onGoodsClick(goods)" v-if="goods.isExpired">
                  <div class="image">
                    <van-image :src="goods.goodsImageUrl" />
                  </div>
                  <div class="grid_bottom goodsGrid" style="width: 100%">
                    <div class="activeText">
                      <div class="activeName">{{ goods.goodsName }}</div>
                      <span class="activedescEnd" v-if="goods.isExpired">活动已截止</span>
                      <div v-else>
                        <span class="activedescEnd" v-if="goods.userLimit >= goods.limitQuantity">限购件数已用完</span>
                        <span class="activedesc" v-if="goods.userLimit < goods.limitQuantity">限购{{ goods.limitQuantity
                          }}件，已购{{
                            goods.userLimit
                          }}件</span>
                      </div>
                      <div class="activeprice">
                        ￥{{ goods.goodsPrice }}
                        <span class="activeLinePrice">￥{{ goods.originPrice }}.00</span>
                      </div>
                    </div>
                  </div>
                </div>
              </van-grid-item>
            </van-grid>
          </div>
          <div v-if="item.moduleType == 'goods'" :id="'id' + item.moduleType" style="padding-top: 3vw">
            <van-grid :column-num="2" gutter="3vw" class="goods-grid">
              <van-grid-item v-for="goods in item.goodsModuleItems" :key="goods.goodsCode"
                style="width: 100%; padding-top: 1px">
                <div @click="onGoodsClick(goods)" style="width: 100%">
                  <div class="image">
                    <div class="topLeft" v-if="
                      goods.fullGift !== '' &&
                      goods.fullGift !== undefined &&
                      goods.fullGift !== null
                    ">
                      <div :class="goods.fullGift.length > 6
                          ? 'topLeftTxt topLeftSTxt'
                          : 'topLeftTxt topLeftBTxt'
                        ">
                        {{ goods.fullGift }}
                      </div>
                    </div>

                    <div class="bottomL" v-if="
                      goods.presale !== '' &&
                      goods.presale !== undefined &&
                      goods.presale !== null
                    ">
                      <div class="bottomLTxt">{{ goods.presale }}</div>
                    </div>
                    <van-image :src="goods.goodsImageUrl" />
                  </div>
                  <div class="grid_bottom goodsGrid" style="width: 100%">
                    <div class="text">
                      <div class="goodsName">{{ goods.goodsName }}</div>
                      <div class="price">
                        ￥{{ goods.goodsPrice }}
                        <span class="linePrice">￥{{ goods.originPrice }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </van-grid-item>
            </van-grid>
          </div>

          <!-- 活动商品 -->
          <!-- <div style="position: absolute;top: 12px;left: 4px;">
                      <van-tag type="danger" mark  size="medium">活动截止</van-tag>
                    </div> -->
          <!-- 显示限购数量，已购数量，如活动结束，显示活动截止字样 -->
          <!-- <div v-if="item.moduleType == 'goods'" :id="'id' + item.moduleType">
            <van-grid :column-num="2" gutter="3vw" class="goods-grid">
              <van-grid-item v-for="goods in item.goodsModuleItems" :key="goods.goodsCode"
                style="width: 100%; padding-top: 3vw">
                <div @click="onGoodsClick(goods)">
                  <div class="image" v-if="goods.goodsId == '111111111111143'">
                    <van-image :src="goods.goodsImageUrl" />
                  </div>
                  <div class="image" v-else>
                    <van-image :src="goods.goodsImageUrl" />
                  </div>
                  <div class="grid_bottom" style="width: 100%">
                    <div class="activeText">
                      <div class="activeName">{{ goods.goodsName }}</div>
                      
                      <div class="activedesc">限购10件，已购2件</div>
                      <div class="activeprice">￥{{ goods.goodsPrice }}
                        <span class="activeLinePrice">￥{{ goods.originPrice }}.00</span>
                      </div>

                    </div>
                  </div>
                </div>
              </van-grid-item>
            </van-grid>
          </div> -->
          <div v-if="item.moduleType == 'richtext'" :id="'id' + item.moduleType">
            <div v-html="item.textContent"></div>
          </div>
          <div v-if="item.moduleType == 'imagenav'" class="image-nav">
            <van-grid :column-num="item.navList.length" :border="false" :clickable="true" icon-size="47px">
              <van-grid-item v-for="(item, index) in item.navList" :class="{ isActive: index === navgatorIndex }"
                :icon="item.imageUrl" :key="item.id" :text="item.title"
                @click="onImageNavClick(item.linkTypeId, item.link_Id)"></van-grid-item>
            </van-grid>
          </div>
          <div v-if="item.moduleType == 'labnav'" :id="'id' + item.moduleType">
            <van-cell-group>
              <van-cell :title="item.title" :is-link="item.isShowMore" :value="item.isShowMore == true ? '更多' : ''" />
            </van-cell-group>
          </div>
          <div :id="'id' + item.moduleType" v-if="item.moduleType == 'picture'" :style="{
            margin:
              item.topMargin + 'px ' + 'auto ' + item.bottomMargin + 'px ',
            display: 'flex',
          }">
            <div :style="{ width: item.width + 'vw ' }"></div>
            <van-image :src="item.pictureUrl" style="background: transparent; flex: 1"
              @click="onPictureClick(item.linkTypeId, item.link_Id)" />
            <div :style="{ width: item.width + 'vw ' }"></div>
          </div>
        </div>
      </div>

      <div v-else class="index-empty">
        <van-empty description="店家正在努力上新中~" />
      </div>
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  Swipe,
  SwipeItem,
  Grid,
  GridItem,
  Card,
  Icon,
  Panel,
  Image,
  Cell,
  Popup,
  Button,
  Col,
  Row,
  Dialog,
  Loading,
  Overlay,
  Empty,
  Tag,
  Toast,
} from "vant";
import pageService from "../../api/page/index";
import { mapGetters, mapActions } from "vuex";
import loading from "../../components/loading/loading";
// import follow from "../../components/follow/index";
// import goods from "../../api/goods";
export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Card.name]: Card,
    [Icon.name]: Icon,
    [Panel.name]: Panel,
    [Image.name]: Image,
    [Cell.name]: Cell,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Col.name]: Col,
    [Row.name]: Row,
    [Dialog.name]: Dialog,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    [Empty.name]: Empty,
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    loading,

    // follow
  },
  props: [],
  data() {
    return {
      IsPopup: true,
      scrollNum: null,
      navgatorIndex: "goods",
      listBoxState: true, //点击导航栏时，暂时停止监听页面滚动
      type: "",
      pageData: {
        moduleList: [],
        backgroundColor: "fff",
        name: "",
        shareDescription: "",
        sharePictureUrl: "",
      },
      padding: "3 3 15 3",
      showEmpty: false,
      goods: {
        finished: true,
        loading: false,
      },
      isLoading: true, //loading状态
      activated: true,
      show: false,
      packagePage: {},
      isShowLoading: true,
      goodsModuleItems: [],
      limitQuantity: "",
      userLimit: "",
      isExpired: false,
    };
  },
  computed: {
    ...mapGetters(["userInfo", "agentShow", "activityPic"]),
    AgentIsShow() {
      return this.agentShow == null ? false : this.agentShow;
    },
    // width() {
    //   let padding = this.padding;
    //   if (!padding) {
    //     return "100%";
    //   }
    //   let paddingArr = padding.split(" ");
    //   if (paddingArr.length == 1) {
    //     return 100 - paddingArr[0] * 2 + "%";
    //   }
    //   if (paddingArr.length >= 2) {
    //     return 100 - paddingArr[1] * 2 + "%";
    //   }
    // },
    // paddingCss() {
    //   let newPadding = [];
    //   let paddingArr = this.padding.split(" ");
    //   paddingArr.map((v, i) => {
    //     if (i == 1 || i == 3) {
    //       newPadding.push(v + "vw");
    //     } else {
    //       newPadding.push(v + "vh");滚动条移动时
    //     }
    //   });

    //   return newPadding.join(" ");
    // },
    // handleScroll() {
    //   let timeId;
    //   // 页面滚动停止100毫秒后才会执行下面的函数。
    //   clearTimeout(timeId);
    //   timeId = setTimeout(() => {
    //     this.scrollToTop();
    //     console.log("执行完了");
    //   }, 1000);
    // }
  },
  methods: {
    ...mapActions(["PageLogin"]),
    // 关闭弹窗 新人首单大礼包弹窗
    // closePop () {
    //   this.IsPopup = false;
    //   let obj = this.activityPic
    //   console.log(obj, 'userInfoObj')
    //   obj.isShowPageActivity = false
    //   this.PageLogin(obj).then(() => {
    //   });
    // },
    clickUrlPackage(packageId) {
      this.$router.push({
        name: "package",
        query: {
          packageId: packageId,
        },
      });
    },
    showPopup() {
      this.show = true;
    },
    cancel(id) {
      Dialog.confirm({
        message: "确认取消订单么",
      })
        .then(() => {
          this.show = false;
        })
        .catch();
    },
    onGoodsClick(link) {
      console.log(link, "link");
      if (link.isExpired) {
        Toast("活动已截止");
      } else {
        this.$router.push({ name: "goods", query: { code: link.goodsId } });
      }
    },
    onPictureClick(linkTypeId, link_Id) {
      switch (linkTypeId) {
        // 商品详情
        case 1:
          this.$router.push({ name: "goods", query: { id: link_Id } });
          break;
        // minipage
        case 2:
          this.$router.push({ name: "miniPage", query: { code: link_Id } });
          break;
        // 打包一口价列表
        case 3:
          this.$router.push({ name: "packageList" });
          break;
        //会员中心
        case 4:
          this.$router.push({ name: "user" });
          break;
        // 购物车
        case 5:
          this.$router.push({ name: "cart" });
          break;
        // order列表
        case 6:
          this.$router.push({ name: "myorder", query: { orderStatusId: "" } });
          break;
        // 套餐包详情
        case 7:
          this.$router.push({ name: "package", query: { id: link_Id } });
          break;
        case 9:
          this.navgatorIndex = "goods";
          this.pageData.map((v) => {
            if (v.moduleType == "goods") {
              this.$el.querySelector(`#id${"goods"}`).scrollIntoView({
                behavior: "smooth", // 平滑过渡
                block: "start", // 上边框与视窗顶部平齐。默认值
              });
            }
          });
          this.listBoxState = false;

          let timeId;
          clearTimeout(timeId);
          timeId = setTimeout(() => {
            this.listBoxState = true;
          }, 200);
          break;
      }
    },
    // 点击导航菜单，页面滚动到指定位置
    onImageNavClick(linkTypeId, link_Id) {
      switch (linkTypeId) {
        // 跳转到商品详情
        case 1:
          // this.navgatorIndex = "goods";
          // this.pageData.map((v) => {
          //   if (v.moduleType == "goods") {
          //     this.$el.querySelector(`#id${"goods"}`).scrollIntoView({
          //       behavior: "smooth", // 平滑过渡
          //       block: "start" // 上边框与视窗顶部平齐。默认值
          //     });
          //   }
          // });
          // this.listBoxState = false;

          // let timeId;
          // clearTimeout(timeId);
          // timeId = setTimeout(() => {
          //   this.listBoxState = true;
          // }, 200);
          this.$router.push({ name: "goods", query: { id: link_Id } });
          break;
        // minipage
        case 2:
          this.$router.push({ name: "miniPage", query: { code: link_Id } });
          break;
        // 打包一口价列表
        case 3:
          this.$router.push({ name: "packageList" });
          break;
        //会员中心
        case 4:
          this.$router.push({ name: "user" });
          break;
        // 购物车
        case 5:
          this.$router.push({ name: "cart" });
          break;
        // order列表
        case 6:
          this.$router.push({ name: "myorder", query: { orderStatusId: "" } });
          break;
        // 套餐包详情
        case 7:
          this.$router.push({ name: "package", query: { id: link_Id } });
          break;
        case 9:
          this.navgatorIndex = "goods";
          this.pageData.map((v) => {
            if (v.moduleType == "goods") {
              this.$el.querySelector(`#id${"goods"}`).scrollIntoView({
                behavior: "smooth", // 平滑过渡
                block: "start", // 上边框与视窗顶部平齐。默认值
              });
            }
          });
          this.listBoxState = false;

          let timeId;
          clearTimeout(timeId);
          timeId = setTimeout(() => {
            this.listBoxState = true;
          }, 200);
          break;
      }
    },
    // scrollToTop() {
    //   // 获取视窗高度
    //   var domHight = document.body.offsetHeight;
    //   // dom滚动位置
    //   var scrollTop =
    //     window.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop;

    //   if (this.listBoxState) {
    //     //作用是点击导航栏时，延迟这里执行。
    //     this.pageData.map((v, i) => {
    //       if (i.moduleType) {
    //         // 获取监听元素距离视窗顶部距离
    //         console.log(
    //           v,
    //           i,
    //           v.moduleType,
    //           i.moduleType,
    //           document.getElementById(`id${i.moduleType}`),
    //           307
    //         );
    //         var offsetTop = document.getElementById(
    //           `id${i.moduleType}`
    //         ).offsetTop;
    //         // 获取监听元素本身高度
    //         var scrollHeight = document.getElementById(
    //           `id${i.moduleType}`
    //         ).scrollHeight;

    //         // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
    //         // 则表示页面已经滚动到可视区了。
    //         if (
    //           scrollTop >= offsetTop &&
    //           scrollTop <= offsetTop + scrollHeight
    //         ) {
    //           // 导航栏背景色选中
    //           this.navgatorIndex = i.moduleType;
    //         }
    //       }
    //     });
    //   }
    // },
    // 获取角标
    subscriptList() {
      pageService.GetSubscriptList().then((res) => {
        if (this.pageData.length !== 0 && res.data.length !== 0) {
          // console.log(this.pageData, 671);
          this.pageData.map((v) => {
            // 商品
            if (v.moduleType == "goods") {
              v.goodsModuleItems.map((i) => {
                res.data.map((f) => {
                  // console.log(f, 677);
                  f.subscriptItems.map((j) => {
                    if (i.goodsId == j.goodsId && f.fullGift) {
                      i.fullGift = f.fullGift;
                    }
                    if (i.goodsId == j.goodsId && f.presale) {
                      i.presale = f.presale;
                    }
                  });
                });
              });
            }
          });
        }
        console.log(this.pageData, 675);
      });
    },
    // 限购
    GetLimitGoods(goodsId) {
      pageService.GetLimitGoodsDetail(goodsId).then((res) => {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        //过期
        let ExpiredList = [];
        // 未过期
        let list = [];
        let data = [];
        this.pageData.map((v) => {
          if (v.moduleType == "limitgoods") {
            for (var i = 0; i < res.data.length; i++) {
              v.goodsModuleItems.map((item) => {
                if (res.data[i].goodsId == item.goodsId) {
                  item.limitQuantity = res.data[i].limitQuantity;
                  item.userLimit = res.data[i].userLimit;
                  item.isExpired = res.data[i].isExpired;
                }
              });
            }
          }
        });
        this.pageData.map((e) => {
          if (e.moduleType == "limitgoods") {
            e.goodsModuleItems.map((j) => {
              if (j.isExpired) {
                ExpiredList.push(j);
              } else {
                list.push(j);
              }
              data = list.concat(ExpiredList);
            });
            e.goodsModuleItems = data;
          }
        });
        // data = ExpiredList.concat(list)
        console.log(ExpiredList, list, data, "ExpiredList");
      });
    },

    init() {
      this.isShowLoading = true;
      this.isLoading = true;
      pageService
        .getModule()
        .then((reponse) => {
          if (reponse.statusCode == 200 && reponse.data == "") {
            this.showEmpty = false;
            setTimeout(() => {
              this.isLoading = false;
            }, 800);
          } else {
            this.showEmpty = true;
            setTimeout(() => {
              this.isLoading = false;
            }, 800);
          }

          this.isShowLoading = false;
          this.pageData = JSON.parse(reponse.data.htmlJson);
          console.log(this.pageData, 525);
          if (this.pageData.length !== 0) {
            var goodsId = [];
            this.pageData.map((v) => {
              // 限购
              if (v.moduleType == "limitgoods") {
                this.goodsModuleItems = v.goodsModuleItems;
                v.goodsModuleItems.map((i) => {
                  goodsId.push(i.goodsId);
                });
              }
            });
            this.GetLimitGoods(goodsId);
          }
          this.subscriptList();
          // console.log(this.pageData.goodsModuleItems);
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          if (error) {
            if (error.status == 404) {
              this.showEmpty = false;
            }
          }
        });
    },
    onSwiperClick: function (linkTypeId, link_Id, item) {
      this.isShowLoading = true;
      switch (linkTypeId) {
        // 商品详情
        case 1:
          this.$router.push({ name: "goods", query: { id: link_Id } });
          break;
        // minipage
        case 2:
          this.$router.push({ name: "miniPage", query: { code: link_Id } });
          break;
        // 打包一口价列表
        case 3:
          this.$router.push({ name: "packageList" });
          break;
        //会员中心
        case 4:
          this.$router.push({ name: "user" });
          break;
        // 购物车
        case 5:
          this.$router.push({ name: "cart" });
          break;
        // order列表
        case 6:
          this.$router.push({ name: "myorder", query: { orderStatusId: "" } });
          break;
        // 套餐包详情
        case 7:
          this.$router.push({ name: "package", query: { id: link_Id } });
          break;
        case 9:
          this.navgatorIndex = "goods";
          this.pageData.map((v) => {
            if (v.moduleType == "goods") {
              this.$el.querySelector(`#id${"goods"}`).scrollIntoView({
                behavior: "smooth", // 平滑过渡
                block: "start", // 上边框与视窗顶部平齐。默认值
              });
            }
          });
          this.listBoxState = false;

          let timeId;
          clearTimeout(timeId);
          timeId = setTimeout(() => {
            this.listBoxState = true;
          }, 200);
          break;
        case 10:
          console.log(1111111,item.functional.value.linkUrl)
          location.href = item.functional.value.linkUrl
          break;
      }
      this.isShowLoading = false;
    },
    // 跳转新人首单大礼包详情页面
    // onActivityClick () {
    //   this.$router.push('activityMinPage')
    // },
  },
  // mounted() {
  //   this.init();
  // },
  destroyed() {
    // 销毁监听
    window.removeEventListener("scroll", this.handleScroll, true);
  },
  activated() {
    //     1、第一次进入缓存界面 beforeRouterEnter --> created --> mounted --> activated --> deactivated
    // 2、第二次进入缓存界面 beforeRouterEnter --> activated --> deactivated
    this.init();
    if (this.scrollNum !== null && this.scrollNum > 0) {
      //确保移动端和pc端都能正确的设置位置
      document.documentElement.scrollTop = this.scrollNum;
      document.body.scrollTop = this.scrollNum;
    }
    this.activated = true;
    // this.$route.meta.isBack = false;
  },
  beforeRouteLeave(to, from, next) {
    // 组件内路由守卫  离开组件前记录页面位置
    //为什么要获取documentElement和body的scrollTop值？因为移动端对documentElement.scrollTop是无效的
    this.scrollNum =
      document.documentElement.scrollTop || document.body.scrollTop;
    next();
  },
  deactivated() {
    this.activated = false;
  },
};
</script>
<style lang="less" scoped>
// use less scaping ands Variable Interpolation
@deep: ~">>>";

.main {
  &-container {
    background: #fff;
    // height: calc(100% - 13vw);
    //
    height: calc(100% - 8vw);
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .pagePopup {
      border-radius: 5vw;
      z-index: 2002;

      .van-grid-item__content {
        padding: 2vw 2.13333vw;
      }
    }

    .tabberHeight {
      padding-bottom: 9vw;
    }

    .image {
      height: 170px;
      width: 100%;
      position: relative;

      .van-image {
        height: 170px;
        width: 100%;

        @{deep} .van-image__img {
          border-radius: 12px 12px 0 0;
          width: 100%;
          height: 100%;
        }
      }

      .topLeft {
        position: absolute;
        width: 70px;
        height: 45px;
        top: 0;
        left: -5px;
        background-image: url(../../../assets/images/left2.png);
        background-size: 70px 45px;
        background-repeat: no-repeat;
        transform: rotate(-22deg);
        z-index: 1;
        -webkit-text-size-adjust: none !important;

        .topLeftTxt {
          font-weight: 700;
          height: 23px;

          color: rgba(255, 0, 0, 1);
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 9px 12px 10px 7px;
        }

        .topLeftBTxt {
          font-size: 10px;
          line-height: 12px;
        }

        .topLeftSTxt {
          font-size: 8px;
          line-height: 9px;
        }
      }

      .bottomL {
        position: absolute;
        width: 90px;
        height: 34px;
        left: 0;
        bottom: 22px;
        background-image: url(../../../assets/images/bottomL.png);
        background-size: 90px 34px;
        background-repeat: no-repeat;
        z-index: 1;
        -webkit-text-size-adjust: none !important;

        .bottomLTxt {
          font-size: 6px;
          font-weight: 700;
          height: 18px;
          letter-spacing: 0px;
          line-height: 8px;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-left: 42px;
          padding-right: 4px;
          padding-top: 12px;
        }
      }
    }
  }
}

// 分享弹窗

.pop_share {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10000;

  .pop_position {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .pop_share_box {
    width: 300px;
    height: 400px;
    background: #ffffff;
    box-shadow: inset 0px -1px 0px 1px rgba(0, 0, 0, 0.05);
    border-radius: 8px 8px 8px 8px;
  }

  .pop_share_save {
    text-align: center;
    margin: 0 auto;
    font-size: 12px;
    width: 100%;
    font-weight: 400;
    color: #ffffff;
    line-height: 12px;
    margin-top: 16px;

    img {
      display: inline-block;
      vertical-align: middle;
      width: 12px;
      height: 12px;
      margin-right: 4px;
    }

    span {
      display: inline-block;
      vertical-align: middle;
    }
  }
}

.text .goodsName {
  font-size: 14px;
  height: 44px;
  line-height: 22px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.text .price {
  margin-top: 8px;
  font-size: 20px;
  line-height: 20px;
  color: rgba(254, 0, 7, 1);
  font-weight: 600;

  .linePrice {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 12px;
    text-decoration-line: line-through;
    color: rgba(102, 102, 102, 1);
    margin-left: 2px;
  }
}

.goodsGrid {
  height: 93px;
}

.grid_bottom {
  width: 100%;
  border-bottom: 0.5px solid rgba(230, 230, 230, 1);
  border-right: 0.5px solid rgba(230, 230, 230, 1);
  border-left: 0.5px solid rgba(230, 230, 230, 1);
  border-bottom-right-radius: 3.2vw;
  border-bottom-left-radius: 3.2vw;

  .line {
    margin-left: 1vw;
    color: #333;
    font-size: 13px;
    text-decoration: line-through;
  }
}

.goodsCol {
  width: 100%;
  border: 1px solid #f4f4f4;
  border-radius: 10px;
}

.text {
  padding-top: 8px;
  margin: 0 8px 12px;
  word-break: break-all;
}

.activeText {
  margin: 2vw 1.5vw;
}

.goodsContent {
  padding: 6px;
}

.index {
  &-show {
    display: block;
  }

  &-hide {
    display: none;
  }

  &-empty {
    display: flex;
    align-items: center;
    flex-direction: column;
    color: #92909a;
    padding-top: 30vw;
  }
}

.packageNum {
  font-size: 3.4vw;
  color: rgb(153, 153, 153);
  padding: 2vw 0 4vw;
  display: flex;
  justify-content: center;
  width: 100%;
}

.cancel {
  border-top: 1px solid #f4f4f4;
}

.buy {
  border-top: 1px solid #f4f4f4;
  border-left: 1px solid #f4f4f4;
}

.pagepackageModule {
  .van-grid-item {
    @{deep} .van-grid-item__content {
      padding: 4.26667vw 4vw;
    }
  }

  .van-card {
    padding: 0;
    width: 80vw;
    background: #fff;
  }

  // .van-card__thumb {
  //   width: 70px;
  //   height: 70px;
  // }
  .van-card__content {
    min-height: 0;
  }

  .van-button--normal {
    padding: 0 12vw;
  }

  .van-card__title {
    max-height: 11.53333vw;
    // font-size: 15px;
    font-weight: bold;
  }

  .van-card__desc {
    padding: 1vw 0;
  }

  .van-card__bottom {
    height: 8vw;
    // .van-card__price {
    //   font-size: 16px;
    //   padding-top: 2vw;
    //   color: #ee0a24;
    // }
  }
}

.goods-grid {
  margin-bottom: 13vw;
}

.limitgoods-grid {
  margin-bottom: 10vw;
}

.goods-grid .van-grid-item__content::after {
  z-index: 1;
  border: none;
}

.limitgoods-grid .van-grid-item__content::after {
  z-index: 1;
  border: none;
}

.van-grid-item__content--center {
  justify-content: initial;
}

@{deep} [class*="van-hairline"]::after {
  border: none;
}

.image-nav .van-grid-item__content {
  background-color: transparent;
}
</style>
